export enum FaceCheckEnum {
  CANCELED = 1, // 取消
  SUCESS = 2, // 通过
  FAILED = 3, // 失败
}

export enum HitchTakePhotoTypeEnum {
  TYPE_IDENTIFICATION_FRONT = '1', // 身份证头像面
  TYPE_IDENTIFICATION_BACK = '2', // 身份证国徽面
  TYPE_DRIVER_LICENSE = '3', // 驾驶证
  TYPE_DRIVING_LICENSE = '4', // 行驶证
  TYPE_CAR = '5', // 车辆拍照
}

export enum HitchTakePhotoShowFrameEnum {
  HIDE = '0', // 不显示画框
  SHOW = '1', // 显示画框
}

export enum CheckScreenShareEnum {
  /** 同步获取 */
  CHECK_SCREEN_SHARE = 'skCheckScreenShare',
  /** 异步获取 */
  CHECK_SCREEN_SHARE_ASYNC = 'skCheckScreenShareAsync',
}

export enum LocationAlertStateEnum {
  CONFIRMED = '0', // 确认
  CANCELED = '1', // 取消
}
